export default __webpack_public_path__ + "static/media/poster_after_content.de75b5b0.png";